import { useContext,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ChangeAlert from '../components/ChangeAlert/ChangeAlert';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Sidebar from '../components/Sidebar/Sidebar';
import DashboardTabs from '../components/Statistics/DashboardTabs';
import { UserContext } from '../context/UserContext';
import { trackEventMatomoVisit } from '../helpers/matomo';
import { HeaderText } from '../StyledComponents/pages/pages';
import { Container,SubContainer } from './Styles';


export default function Statistics() {
  const { changed } = useContext(UserContext);
  const { t } = useTranslation('translation');

  useEffect(() => {
    trackEventMatomoVisit('Estatísticas');
  }, []);

  return (
    <Container>
      <Sidebar />
      <SubContainer>
        {changed && <ChangeAlert />}
        <Header />
        <HeaderText style={{ textAlign: 'center' }}>{t('Dashboard.title')}</HeaderText>
        <div style={{
          padding: '5px'}}>
          <DashboardTabs/>
        </div>
        <Footer />
      </SubContainer>
    </Container>
  );
}
